// ** Third Party Components
import classnames from 'classnames'
import { P } from 'components'
import Proptypes from 'prop-types'
import { useEffect } from 'react'
import { ArrowLeft, X } from 'react-feather'
import { Modal, ModalBody, ModalFooter } from 'reactstrap'

const SidebarDetails = (props) => {
  // ** Props
  const {
    width,
    open,
    toggleSidebar,
    size,
    bodyClassName,
    contentClassName,
    wrapperClassName,
    headerClassName,
    className,
    title,
    children,
    closeBtn,
    noClose = false,
    isBack = true,
    handleBack,
    isNavbar = false,
    noHeader = false,
    isLeftAnimation = false,
    footerContent,
    ...rest
  } = props

  // ** If user passes custom close btn render that else default close btn
  const renderCloseBtn = !noClose ? (
    closeBtn ? (
      closeBtn
    ) : (
      <X
        className="pe-auto"
        style={{
          cursor: 'pointer',
        }}
        size={20}
        onClick={toggleSidebar}
        data-testid="sidebar-details-close"
      />
    )
  ) : (
    <></>
  )

  useEffect(() => {
    if (isNavbar && open) {
      document.body.style.overflow = 'auto'
    } else if (!isNavbar && open) {
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [isNavbar, open])

  return (
    <Modal
      isOpen={open}
      toggle={toggleSidebar}
      data-testid="sidebar-details"
      contentClassName={classnames({
        [contentClassName]: contentClassName,
      })}
      modalClassName={classnames(
        `${isLeftAnimation ? 'modal-slide-in-left' : 'modal-slide-in'}`,
        {
          [wrapperClassName]: wrapperClassName,
        },
      )}
      className={classnames({
        [className]: className,
        'SidebarDetails-lg': size === 'lg',
        'SidebarDetails-sm': size === 'sm',
        'sidebar-navbar': isNavbar,
      })}
      style={{
        ...(width !== undefined &&
          !isNavbar && { width: String(width) + 'px' }),
        ...(isNavbar && { left: 0, right: 'auto', width: '300px' }),
        backgroundColor: 'white',
      }}
      {...rest}
    >
      {noHeader ? (
        <></>
      ) : (
        <div
          className={
            'd-flex justify-content-between ' +
            classnames({
              [headerClassName]: headerClassName,
            })
          }
          toggle={toggleSidebar}
          close={renderCloseBtn}
          tag="div"
          style={{ padding: 20 }}
        >
          <div className="d-flex align-items-center gap-2">
            {isBack && (
              <ArrowLeft
                style={{ cursor: 'pointer' }}
                onClick={handleBack ?? toggleSidebar}
                data-testid="sidebar-details-back"
              />
            )}
            <P className="align-middle" bold>
              {title}
            </P>
          </div>
        </div>
      )}
      <ModalBody
        style={{ backgroundColor: '#F8F9FA', overflowY: 'auto' }}
        className={classnames('flex-grow-1', {
          [bodyClassName]: bodyClassName,
        })}
      >
        {children}
      </ModalBody>
      {footerContent && (
        <ModalFooter
          className="border-top bg-white"
          style={{ position: 'sticky', bottom: 0, zIndex: 1 }}
        >
          {footerContent}
        </ModalFooter>
      )}
    </Modal>
  )
}

export default SidebarDetails

// ** PropTypes
SidebarDetails.propTypes = {
  title: Proptypes.string.isRequired,
  open: Proptypes.bool.isRequired,
  toggleSidebar: Proptypes.func.isRequired,
  size: Proptypes.oneOf(['sm', 'lg']),
  className: Proptypes.string,
  bodyClassName: Proptypes.string,
  contentClassName: Proptypes.string,
  wrapperClassName: Proptypes.string,
  children: Proptypes.any.isRequired,
  width: Proptypes.oneOfType([Proptypes.number, Proptypes.string]),
  isNavbar: Proptypes.bool,
}
